import React, { useState, useEffect } from "react";
import {
  LinearProgress,
  makeStyles,
  createStyles,
  Fade,
} from "@material-ui/core";
import classNames from "classnames";

// CSSスタイルを定義
const useStyles = makeStyles((theme) =>
  createStyles({
    progressBar: {
      height: "2px",
    },
    bar: {
      transition: "none",
    },
  })
);

export default function ProgressBar(props) {
  const { isLoading, className } = props;
  const classes = useStyles();

  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((oldProgress) => {
        if (!isLoading) {
          return 0;
        }

        const diff = Math.random() * 10; // 0～10の値をランダムに選出
        return Math.min(oldProgress + diff, 95); // 値が95になるまで加算
      });
    }, 100);

    return () => {
      clearInterval(timer);
    };
  }, [isLoading]);

  return (
    <Fade in={progress !== 0} timeout={{ exit: 500 }}>
      <LinearProgress
        variant="determinate"
        value={isLoading ? progress : 100}
        className={classNames(classes.progressBar, className)}
        classes={progress === 0 ? { bar: classes.bar } : null}
        color="secondary"
      />
    </Fade>
  );
}
